var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJetxLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 17,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.17 4.327L7 10.717s-.2 1.32-1.45 1.32H1.3L0 14.667h6.09s3.33.03 4-3.33c.67-3.36 1.72-9.47 1.72-9.47H6.18l-1.17 2.46h3.16zm2.68 7.376s-.45 2.99 2.02 2.99h7.47l-1.43-2.63h-4.3s-.67.11-.6-.62c.06-.72.91-4.9.91-4.9s.14-.48.65-.48h3.13s.36.07.34.44c-.04.35-.18 1.38-.18 1.38h-3.91l-.45 2.4h6.78l.71-4.66s.45-2.06-2.37-2.06h-4.38s-2.87-.27-3.43 2.83l-.96 5.31zm19.355.399h-4.23c-.58 0-.4-.48-.4-.48l1.05-5.52h4.97l-1.28-2.59h-3.09l.47-2.48h-3.46s-1.32 7.07-1.93 10.41c-.6 3.34 1.97 3.25 1.97 3.25h3.76l2.17-2.59z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.93 0l-3.22 3.69h1.21l-1.5.35-1.32 1.52-.92-1.74 1.59-.35h-1.79l-.7-1.32H31.3l.78 1.54h1.24l-1.1.26 2.33 4.53-1.23 1.43h.67l-.85.19-3.56 4.11h.74l-.94.22L27.14 17h4.36l1.97-2.31 1.08-.24h-.88l2.46-2.88 1.75 3.34h4.18l-.31-.59.49-.11h-.53l-2.26-4.24.62-.15h-.71l-.68-1.25 3.96-4.62 1.48-.35h-1.18L46 0h-4.07z",
    fill: "#ffeb3b"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJetxLogo);
export default __webpack_public_path__ + "static/media/jetx-logo.21897de6e60eedfc99e01f506d1a8c5a.svg";
export { ForwardRef as ReactComponent };